import { type RoadMapUpdate } from '@/domain/roadmap/types';

export const initialValue: RoadMapUpdate = {
  description: '',
  detailedDescription: '',
  item: '',
  qualityCertificate: '',
  specification: '',
  versionChangesCount: 0,
  itemChangesCount: 0,
  idProduct: 0,
  product: null,
  idRoadmap: 0,
  milestones: [],
  plants: [],
  okrs: [],
  status: null,
  type: null,
  version: null,
  owner: null,
  fundingSources: [],
  priority: 0,
  classification: 0,
  category: 0,
  plannedHours: 0,
  origin: 0,
  responsibleIds: [],
  locked: false,
  unitsImpact: [],
  externalOrigin: '',
  linkedItems: [],
};
